import { supabase } from "@/integrations/supabase/client";

export interface SearchMetrics {
  query: string;
  resultsCount: number;
  searchDuration: number;
  strategy: string;
  success: boolean;
  userSession: string;
}

export const trackSearchMetrics = async (metrics: SearchMetrics) => {
  try {
    await supabase.from('search_analytics').insert({
      search_query: metrics.query,
      results_count: metrics.resultsCount,
      interaction_type: 'search_execution',
      user_session: metrics.userSession,
      search_criteria: {
        strategy: metrics.strategy,
        duration: metrics.searchDuration,
        success: metrics.success
      }
    });
  } catch (error) {
    console.error('Failed to track search metrics:', error);
  }
};

export const trackVacationClick = async (
  vacationId: number, 
  position: number, 
  query: string,
  userSession: string
) => {
  try {
    await supabase.from('search_analytics').insert({
      search_query: query,
      results_count: 0,
      interaction_type: 'vacation_click',
      user_session: userSession,
      clicked_vacation_id: vacationId,
      vacation_position: position,
      search_criteria: {
        click_position: position,
        timestamp: new Date().toISOString()
      }
    });
  } catch (error) {
    console.error('Failed to track vacation click:', error);
  }
};

export const getPopularSearches = async (limit: number = 10) => {
  try {
    const { data } = await supabase
      .from('search_performance')
      .select('search_query, click_through_rate, total_searches')
      .gte('click_through_rate', 0.1)
      .gte('total_searches', 5)
      .order('click_through_rate', { ascending: false })
      .limit(limit);
    
    return data || [];
  } catch (error) {
    console.error('Failed to get popular searches:', error);
    return [];
  }
};

export const getSearchSuggestions = async (query: string) => {
  try {
    const { data } = await supabase.functions.invoke('get-smart-suggestions');
    return data?.suggestions || [];
  } catch (error) {
    console.error('Failed to get search suggestions:', error);
    return [];
  }
};

export const improveSearchQuality = async (
  originalQuery: string,
  improvedQuery: string,
  reason: string
) => {
  try {
    await supabase.from('query_improvements').insert({
      original_query: originalQuery,
      improved_criteria: { enhanced_query: improvedQuery },
      improvement_reason: reason,
      success_score: 0.8,
      active: true
    });
  } catch (error) {
    console.error('Failed to save search improvement:', error);
  }
};